/**
 * TanStack Query hooks for `custom-quote-pricing-post-starter`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customQuotePricingPostStarterQueryKeys,
	type CreateCustomQuotePricingPostStarterBody,
	type ListCustomQuotePricingPostStarterResponse,
	type CustomQuotePricingPostStarterRow,
} from "./api";

export function useCustomQuotePricingPostStarterList(): UseQueryResult<ListCustomQuotePricingPostStarterResponse, Error> {
	return useQuery({
		queryKey: customQuotePricingPostStarterQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomQuotePricingPostStarterCreate(): UseMutationResult<CustomQuotePricingPostStarterRow, Error, CreateCustomQuotePricingPostStarterBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customQuotePricingPostStarterQueryKeys.all });
		},
	});
}

export function useCustomQuotePricingPostStarterDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customQuotePricingPostStarterQueryKeys.all });
		},
	});
}
